// support spf collection for legacy purposes
define('fukit/collection/spf.collection',['require','exports','module','./base.collection'],function(require, exports, module) {
  var BaseCollection = require('./base.collection');

  module.exports = BaseCollection;
});

